// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  deleteChronicIntervention,
  addChronicIntervention,
  updateChronicIntervention,
  deleteAcuteIntervention,
  addAcuteIntervention,
  updateAcuteIntervention,
} from '../../../actions/treatmentActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  activePatientId: string,
  interventions: Object[],
  problemId: string,
  addChronicIntervention: Function,
  deleteChronicIntervention: Function,
  updateChronicIntervention: Function,
  addAcuteIntervention: Function,
  deleteAcuteIntervention: Function,
  updateAcuteIntervention: Function,
  acute: boolean,
  chronic: boolean,
}

class ProblemInterventionTableComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.startDate = moment(formValues.startDate, 'DD-MM-YYYY').toISOString();
    formValues.endDate = moment(formValues.endDate, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    if (this.props.acute) {
      this.props.deleteAcuteIntervention(this.props.activePatientId, id);
    } else if (this.props.chronic) {
      this.props.deleteChronicIntervention(this.props.activePatientId, id);
    }
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    if (this.props.acute) {
      this.props.updateAcuteIntervention(this.props.activePatientId,
        {
          treatmentId: id,
          ...formData.values,
        });
    } else if (this.props.chronic) {
      this.props.updateChronicIntervention(this.props.activePatientId,
        {
          treatmentId: id,
          ...formData.values,
        });
    }
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    if (this.props.acute) {
      this.props.addAcuteIntervention(this.props.activePatientId, {
        problemId: this.props.problemId,
        ...formData.values,
      });
    } else if (this.props.chronic) {
      this.props.addChronicIntervention(this.props.activePatientId, {
        problemId: this.props.problemId,
        ...formData.values,
      });
    }
  }

  render() {
    const columns = [
      {
        Header: 'Start Date',
        id: 'startDate',
        cell: item => (item.startDate ? moment(item.startDate).format() : '--'),
        editCell: item => <DateText field='startDate' item={item} />,
        width: 100,
      },
      {
        Header: 'End Date',
        id: 'endDate',
        cell: item => (item.endDate ? moment(item.endDate).format() : '(ongoing)'),
        editCell: item => <DateText field="endDate" item={item} nullable />,
        width: 100,
      },
      {
        Header: 'Name',
        id: 'name',
        editCell: item => <Typeahead field='name' initialValue={item.name} endpoint='intervention' />,
      },
    ];

    let { interventions } = this.props;
    interventions = interventions.sort((a, b) => {
      if (a.endDate && !b.endDate) {
        return 1;
      }
      if (b.endDate && !a.endDate) {
        return -1;
      }
      return 0;
    });

    return (
      <Table
        columns={columns}
        data={interventions}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}


const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addChronicIntervention:
    (patientId, intervention) => dispatch(addChronicIntervention(patientId, intervention)),
  deleteChronicIntervention:
    (patientId, interventionId) => dispatch(deleteChronicIntervention(patientId, interventionId)),
  updateChronicIntervention:
    (patientId, intervention) => dispatch(updateChronicIntervention(patientId, intervention)),
  addAcuteIntervention:
    (patientId, intervention) => dispatch(addAcuteIntervention(patientId, intervention)),
  deleteAcuteIntervention:
    (patientId, interventionId) => dispatch(deleteAcuteIntervention(patientId, interventionId)),
  updateAcuteIntervention:
    (patientId, intervention) => dispatch(updateAcuteIntervention(patientId, intervention)),
});

const ProblemInterventionTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProblemInterventionTableComponent);

export default ProblemInterventionTable;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/ProblemInterventionTable.jsx